import React from "react";
import { connect } from "react-redux";
import { Breadcrumb, Button, Form, FormControl, ControlLabel } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { debounce } from "throttle-debounce";
import { Event } from "components/Comet";
import Loading from "components/Loading";
import Request from "request";
import locale from "locale";
import "./style";

const bannerDimensions = {
	width: 1635,
	height: 122,
}

class Banner extends React.Component {
	constructor(props, context) {
		super(props, context);

		const { link, timeout } = this.props;

		this.state = {
			link,
			timeout,
			fileUpload: null
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleUploadFileClick = this.handleUploadFileClick.bind(this);
		this.handleUploadFileChange = this.handleUploadFileChange.bind(this);
		this.sendUpdate = debounce(1000, this.sendUpdate.bind(this));
	}

	handleChange(e) {
		let { name, value, type } = e.target;
		switch (type) {
			case 'checkbox': value = e.target.checked; break;
			case 'number': value = parseInt(value) || 0; break;
		}
		this.setState({ [name]: value });
		this.sendUpdate();
	}
	handleUploadFileClick() {
		this.fileInput.click();
	}
	handleUploadFileChange() {
		const fileUpload = this.fileInput.files[0];
		this.setState({ fileUpload });
		this.sendUpdate();
	}

	sendUpdate() {
		const { onChange } = this.props;

		const data = {
			link: this.state.link,
			timeout: this.state.timeout,
			file: this.state.fileUpload
		};

		onChange(data);
	}

	render() {
		const { id, url, onDelete } = this.props;
		const { link, timeout } = this.state;

		return (
			<div style={{ backgroundImage: `url(${url})` }} className="Banner">
				<div className="BannerControls">
					<Form>
						<div>
							<ControlLabel>Адрес</ControlLabel>
							<FormControl type="text" bsSize="small" name="link" value={link || ''} onChange={this.handleChange.bind(this)} />
							<input type="file" style={{ display: 'none' }} ref={ref => this.fileInput = ref} onChange={this.handleUploadFileChange} />
							<Button bsSize="small" onClick={this.handleUploadFileClick}>Загрузить</Button>
						</div>
						<div>
							<ControlLabel>Время ротации</ControlLabel>
							<FormControl type="number" bsSize="small" name="timeout" value={timeout || 60} onChange={this.handleChange.bind(this)} />
							<Button bsSize="small" onClick={() => onDelete(id)}>Удалить</Button>
						</div>
					</Form>
				</div>
			</div>
		);
	}
}

class PageBanners extends React.Component {
	state = {
		isLoading: true,
		banners: []
	};

	constructor(props, context) {
		super(props, context);

		this.handleCreateBanner = this.handleCreateBanner.bind(this);
		this.handleUpdateBanner = this.handleUpdateBanner.bind(this);
		this.handleDeleteBanner = this.handleDeleteBanner.bind(this);

		this.onCreateBanner = this.onCreateBanner.bind(this);
		this.onUpdateBanner = this.onUpdateBanner.bind(this);
		this.onDeleteBanner = this.onDeleteBanner.bind(this);
	}

	componentDidMount() {
		const { event: { eventPassword } } = this.props;

		Request.get(`/api/cp/event/${eventPassword}/banner`)
			.then(banners => this.setState({ banners }))
			.catch(() => { })
			.then(() => this.setState({ isLoading: false }));
	}

	handleCreateBanner() {
		const { event: { eventPassword } } = this.props;

		Request.post(`/api/cp/event/${eventPassword}/banner`)
			.then(this.onCreateBanner)
			;
	}
	handleUpdateBanner(id, data) {
		const { event: { eventPassword } } = this.props;

		Request.post(`/api/cp/event/${eventPassword}/banner/${id}`, data)
			.then(this.onUpdateBanner)
			;
	}
	handleDeleteBanner(id) {
		const { event: { eventPassword } } = this.props;

		Request.delete(`/api/cp/event/${eventPassword}/banner/${id}`)
			.then(this.onDeleteBanner)
			;
	}

	onCreateBanner(data) {
		this.onUpdateBanner(data);
	}
	onUpdateBanner(data) {
		const banners = this.state.banners.slice();
		const index = banners.findIndex(banner => banner.id === data.id);
		if (index >= 0) {
			banners[index] = Object.assign({}, banners[index], data);
		} else {
			banners.push(data);
		}
		this.setState({ banners });
	}
	onDeleteBanner(data) {
		const banners = this.state.banners.slice();
		const index = banners.findIndex(banner => banner.id === data.id);
		if (index >= 0) {
			banners.splice(index, 1);
			this.setState({ banners });
		}
	}

	render() {
		const { isLoading, banners } = this.state;
		const { event } = this.props;
		const { eventPassword } = event;

		if (isLoading) return <Loading>Загрузка банеров</Loading>;

		const { width, height } = bannerDimensions;
		const aspectRatio = `${Math.floor(width / (height / 3))}  / 3`

		return (
			<section className="PageBanners">
				<Breadcrumb>
					<LinkContainer to={`/event/${eventPassword}`}>
						<Breadcrumb.Item>{locale('mainMenu.interactive')}</Breadcrumb.Item>
					</LinkContainer>
					<Breadcrumb.Item active>{locale('mainMenu.banners')}</Breadcrumb.Item>
				</Breadcrumb>

				<Event event="create:poll" handler={this.onCreateBanner} />
				<Event event="update:poll" handler={this.onUpdateBanner} />
				<Event event="delete:poll" handler={this.onDeleteBanner} />

				<div style={{ width: 600, margin: '0 auto' }}>
					{banners.map(banner =>
						<Banner {...banner} event={event} key={banner.id}
							onChange={data => this.handleUpdateBanner(banner.id, data)}
							onDelete={() => this.handleDeleteBanner(banner.id)} />
					)}
					<Button bsSize="large" style={{ width: 600 }}
						onClick={this.handleCreateBanner}>Создать баннер</Button>
					<div style={{ marginTop: '2rem', textAlign: 'center' }}>
						Изображение выводится с соотношением сторон <b>{aspectRatio}</b><br />
						Рекомендуемый размер изображения для баннера <b>{width}х{height} px</b>
						<div className="banner-preview" style={{ aspectRatio }}>
							<svg width='100%' height='100%' viewBox='0 0 100 100' preserveAspectRatio='none'>
								<line x1="0" y1="0" x2="100" y2="100" vectorEffect="non-scaling-stroke" stroke="rgb(163, 163, 163)" />
								<line x1="0" y1="100" x2="100" y2="0" vectorEffect="non-scaling-stroke" stroke="rgb(163, 163, 163)" />
							</svg>
							<span className="width">{width}</span>
							<span className="height">{height}</span>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(PageBanners);
